import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';

import { Api } from './api.service';
import {ListInterface} from './crud.interface';
import { PAGINATION_NUMBER } from './constants.service';
import { Tracker, ListResult } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class TrackerB2bService implements ListInterface<Tracker> {

  constructor(protected http: Api) {}

  @Log('green')
  list(search: string = null, page: number = 1, limit: number = PAGINATION_NUMBER): Observable<ListResult<Tracker>> {
    const params = new URLSearchParams();
    if (search) {
      params.set('search', String(search));
    }
    if (page) {
      params.set('page', String(page));
    }
    if (limit) {
      params.set('limit', String(limit));
    }

    return this.http.get('b2b-trackers', { search: params });
  }}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/tracker-b2b.service.ts